import { useEffect, useState } from "react";
import {
  useBusinessMypageAlarmInfo,
  useUpdateBusinessMypageAlarmInfo,
} from "~/services/business/myPage";
import { BusinessAlarmInfoResponse } from "../../../api/types/common";

const useOwnerPush = () => {
  const { data: businessAlarmInfo, isLoading } = useBusinessMypageAlarmInfo();
  const [pushInfo, setPushInfo] = useState<BusinessAlarmInfoResponse | null>(null);
  const updateAlarmInfo = useUpdateBusinessMypageAlarmInfo();

  useEffect(() => {
    if (businessAlarmInfo && businessAlarmInfo.bizUserSeq) {
      setPushInfo(businessAlarmInfo as BusinessAlarmInfoResponse);
    }
  }, [businessAlarmInfo]);

  const handlePushInfo = async (
    key: keyof BusinessAlarmInfoResponse,
    value: string
  ) => {
    const newPushInfo = {
      ...pushInfo,
      [key]: value,
    };
    setPushInfo(newPushInfo as BusinessAlarmInfoResponse);
    if (newPushInfo.bizUserSeq) {
      try {
        await updateAlarmInfo.mutateAsync({
          alarmEmailYn: newPushInfo.alarmEmailYn || "N",
          alarmMarketingYn: newPushInfo.alarmMarketingYn || "N",
          alarmNoticeYn: newPushInfo.alarmNoticeYn || "N",
          alarmSmsYn: newPushInfo.alarmSmsYn || "N",
          kakaoAlimUseYn: newPushInfo.kakaoAlimUseYn || "N",
          kakaoAlimFallbackSmsYn: newPushInfo.kakaoAlimFallbackSmsYn || "N",
          bizUserSeq: newPushInfo.bizUserSeq,
        });
      } catch (error) {
        console.error("비즈니스 알림 설정 업데이트 실패:", error);
        // 실패 시 이전 상태로 복구
        setPushInfo(pushInfo);
      }
    }
  };

  return {
    pushInfo,
    handlePushInfo,
    isUpdating: updateAlarmInfo.isPending,
    isLoading,
  };
};

export default useOwnerPush;
